import React, { useState } from "react";
import { Link } from "react-router-dom";
import ThemeToggleButton from "./ThemeToggleButton";

const AdminNavbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("tokenAcesso");
    localStorage.removeItem("user");
    // window.location.href = "login";
  };

  return (
    <div className="navbar fixed top-0 mx-auto shadow-xl bg-base-200 z-10 mb-12">
      <div className="navbar-start">
        <div className={`dropdown ${mobileOpen ? "dropdown-open" : ""}`}>
          <button
            className="btn btn-ghost lg:hidden"
            aria-label="Abrir menu"
            onClick={() => setMobileOpen((v) => !v)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
          <ul className="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-box w-52">
            <li>
              <Link to="/admin" onClick={() => setMobileOpen(false)}>
                Fotos
              </Link>
            </li>
            <li>
              <Link to="/admin/atletas" onClick={() => setMobileOpen(false)}>
                Atletas
              </Link>
            </li>
            <li>
              <Link
                to="/admin/compras/aprovar"
                onClick={() => setMobileOpen(false)}
              >
                Aprovações
              </Link>
            </li>
            <li>
              <Link
                to="/admin/parametros/pix"
                onClick={() => setMobileOpen(false)}
              >
                PIX
              </Link>
            </li>
            <li>
              <Link to="/admin/logs" onClick={() => setMobileOpen(false)}>
                Logs
              </Link>
            </li>
            <li>
              <Link to="/ar/shop" onClick={() => setMobileOpen(false)}>
                Loja
              </Link>
            </li>
            <li>
              <Link to="/admin/descontos" onClick={() => setMobileOpen(false)}>
                Descontos
              </Link>
            </li>
          </ul>
        </div>
        <Link to="/" onClick={logout} className="btn">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="32px"
            width="32px"
            viewBox="0 -960 960 960"
            fill="#000000"
          >
            <path d="M202.57-140q-25.79 0-44.18-18.39T140-202.57v-554.86q0-25.79 18.39-44.18T202.57-820h277.4v50.26h-277.4q-4.62 0-8.47 3.84-3.84 3.85-3.84 8.47v554.86q0 4.62 3.84 8.47 3.85 3.84 8.47 3.84h277.4V-140h-277.4Zm459.38-181.54-35.85-35.95 97.39-97.38H363.85v-50.26h358.82l-97.39-97.38 35.59-36.21L820-479.46 661.95-321.54Z" />
          </svg>
        </Link>
      </div>

      <div className="navbar-center hidden lg:flex">
        <ul className="menu menu-horizontal px-1">
          <li>
            <Link to="/admin" className="btn">
              Fotos
            </Link>
          </li>
          <li>
            <Link to="/admin/atletas" className="btn">
              Atletas
            </Link>
          </li>
          <li>
            <Link to="/admin/compras/aprovar" className="btn">
              Aprovações
            </Link>
          </li>
          <li>
            <Link to="/admin/parametros/pix" className="btn">
              PIX
            </Link>
          </li>
          <li>
            <Link to="/admin/logs" className="btn">
              Logs
            </Link>
          </li>
          <li>
            <Link to="/ar/shop" className="btn">
              Loja
            </Link>
          </li>
          <li>
            <Link to="/admin/descontos" className="btn">
              Descontos
            </Link>
          </li>
        </ul>
      </div>

      <div className="navbar-end">
        <ThemeToggleButton />
      </div>
    </div>
  );
};

export default AdminNavbar;
